import { render, staticRenderFns } from "./TypesPerTargetWidget.vue?vue&type=template&id=105a9e4a"
import script from "./TypesPerTargetWidget.vue?vue&type=script&lang=ts"
export * from "./TypesPerTargetWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports